import { BaseUserProfile } from '../users/BaseUserProfile';
import { Meal } from './meal';
import { DayOfWeek, MealOfDay, MealPlanData } from './mealplan';

export class UserMealPlan extends MealPlanData {
    public static amountOfDietDaysPerWeek = 7;
    public static amountOfmealsPerDay = 5;

    public static Create(mealPlanWithMeals: MealPlanData, user: BaseUserProfile): UserMealPlan {
        const newObj = new UserMealPlan();
        newObj.mealIdSchedule = mealPlanWithMeals.mealIdSchedule;
        newObj.shoppingListExclusions = mealPlanWithMeals.shoppingListExclusions;
        newObj.userId = user.uid;
        newObj.displayName = mealPlanWithMeals.displayName;
        newObj.dietGoal = mealPlanWithMeals.dietGoal;
        newObj.foodPreference = mealPlanWithMeals.foodPreference;
        newObj.gender = mealPlanWithMeals.gender;
        newObj.organisation = mealPlanWithMeals.organisation;
        return newObj;
    }

    public static SetMeal(
        userMealPlan: UserMealPlan,
        meal: Meal,
        dayOfWeek: DayOfWeek,
        mealOfDay: MealOfDay): UserMealPlan {
        const dayMeals = userMealPlan.mealIdSchedule.get(dayOfWeek);
        if (dayMeals) {
            dayMeals.set(mealOfDay, meal._id);
        }
        return userMealPlan;
    }

    public static GenerateIdFromUserPlan(userMealPlan: UserMealPlan): string {
        return userMealPlan.userId + '_' + MealPlanData.GenerateIdFromPlan(userMealPlan);
    }

    public userId: string;
}
